/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'reservations',
        title: 'Rezervace',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/reservations'
    },
    {
        id   : 'users',
        title: 'Správa uživatelů',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'patients',
        title: 'Správa dárců',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/patients'
    },
    {
        id   : 'reservation-types',
        title: 'Typy odběrů',
        type : 'basic',
        icon : 'heroicons_outline:menu',
        link : '/reservation-types'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
